import { Injectable } from '@angular/core'

import { SESSION_STORAGE_CONSTANTS_CAAS_CONTENT } from '../../constants/constant.content'
import { FundRuleName } from '../services/data-filters/rules/fund-rule-name'
@Injectable()
export class AssetClassModel {
  assetCaas: any
  public isFilterByLevel1Clicked = false
  public equityLevel2 = [
    {
      id: 'eqUs',
      rule: FundRuleName.EQUITY_US,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'eqIntl',
      rule: FundRuleName.EQUITY_INTERNATIONAL,
      text: '',
      value: false,
      productTypes: [],
    },

    {
      id: 'eqDev',
      rule: FundRuleName.EQUITY_DEVELOPED,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'eqEmrg',
      rule: FundRuleName.EQUITY_EMERGING,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'eqGl',
      rule: FundRuleName.EQUITY_GLOBAL,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'eqNUs',
      rule: FundRuleName.EQUITY_NON_US,
      text: '',
      value: false,
      productTypes: [],
    },

    {
      id: 'blend',
      rule: FundRuleName.EQUITY_BLEND,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'gr',
      rule: FundRuleName.EQUITY_GROWTH,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'val',
      rule: FundRuleName.EQUITY_VALUE,
      text: '',
      value: false,
      productTypes: [],
    },

    {
      id: 'lrg',
      rule: FundRuleName.EQUITY_LARGE,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'mid',
      rule: FundRuleName.EQUITY_MID,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'sm',
      rule: FundRuleName.EQUITY_SMALL,
      text: '',
      value: false,
      productTypes: [],
    },

    {
      id: 'eqActv',
      rule: FundRuleName.EQUITY_ACTIVE,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'eqIndex',
      rule: FundRuleName.EQUITY_INDEX,
      text: '',
      value: false,
      productTypes: [],
    },
  ]
  public fixedincomeLevel2 = [
    {
      id: 'fiUs',
      rule: FundRuleName.FI_US,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'fiIntl',
      rule: FundRuleName.FI_INTERNATIONAL,
      text: '',
      value: false,
      productTypes: [],
    },

    {
      id: 'fiDev',
      rule: FundRuleName.FI_DEVELOPED,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'fiEmrg',
      rule: FundRuleName.FI_EMERGING,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'fiGl',
      rule: FundRuleName.FI_GLOBAL,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'fiNUS',
      rule: FundRuleName.FI_NON_US,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'MultiS',
      rule: FundRuleName.FI_MULTI_SECTOR,
      text: '',
      value: false,
      productTypes: [],
    },

    {
      id: 'bInvGr',
      rule: FundRuleName.FI_BELOW_INV_GRADE,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'invGr',
      rule: FundRuleName.FI_INV_GRADE_CORP,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'fiMu',
      rule: FundRuleName.FI_MUNI,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'tAgncy',
      rule: FundRuleName.FI_TREASURY_AGENCY,
      text: '',
      value: false,
      productTypes: [],
    },

    {
      id: 'lng',
      rule: FundRuleName.FI_LONG,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'interm',
      rule: FundRuleName.FI_INTERMEDIATE,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'sh',
      rule: FundRuleName.FI_SHORT,
      text: '',
      value: false,
      productTypes: [],
    },

    {
      id: 'fiActv',
      rule: FundRuleName.FI_ACTIVE,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'fiIndex',
      rule: FundRuleName.FI_INDEX,
      text: '',
      value: false,
      productTypes: [],
    },
  ]
  public multiAssetLevel2 = [
    {
      id: 'muUs',
      rule: FundRuleName.MULTI_ASSET_US,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'muIntl',
      rule: FundRuleName.MULTI_ASSET_INTL,
      text: '',
      value: false,
      productTypes: [],
    },

    {
      id: 'bal',
      rule: FundRuleName.MULTI_ASSET_BALANCE,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'trgAlloc',
      rule: FundRuleName.MULTI_ASSET_TARGET_ALLOCATION,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'trgDt',
      rule: FundRuleName.MULTI_ASSET_TARGET_DATE,
      text: '',
      value: false,
      productTypes: [],
    },
  ]
  public cashEquivalentLevel2 = [
    {
      id: 'tx',
      rule: FundRuleName.CASH_EQUIVALENTS_TAXABLE,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'ceMu',
      rule: FundRuleName.CASH_EQUIVALENTS_MUNI,
      text: '',
      value: false,
      productTypes: [],
    },
    {
      id: 'ceStb',
      rule: FundRuleName.CASH_EQUIVALENTS_STABLE_VALUE,
      text: '',
      value: false,
      productTypes: [],
    },
  ]
  public filterByLevel1 = {
    equity: {
      id: 'eq',
      rule: FundRuleName.EQUITY,
      text: '',
      value: false,
      level2: this.equityLevel2,
    },
    fixedIncome: {
      id: 'fi',
      rule: FundRuleName.FIXED_INCOME,
      text: '',
      value: false,
      level2: this.fixedincomeLevel2,
    },
    multiAsset: {
      id: 'muAst',
      rule: FundRuleName.MULTI_ASSET,
      text: '',
      value: false,
      level2: this.multiAssetLevel2,
    },
    cashEquivalent: {
      id: 'ce',
      rule: FundRuleName.CASH_EQUIVALENT,
      text: '',
      value: false,
      level2: this.cashEquivalentLevel2,
    },
    factorDriven: {
      id: 'factDr',
      rule: FundRuleName.FACTOR_DRIVEN_STRATEGY,
      text: '',
      value: false,
      level2: undefined,
    },
    esg: {
      id: 'esg',
      rule: FundRuleName.ESG_STRATEGY,
      text: '',
      value: false,
      level2: undefined,
    },
    sectorSpecialties: {
      id: 'secspec',
      rule: FundRuleName.SECTOR_SPECIALITY_STRATEGY,
      text: '',
      value: false,
      level2: undefined,
    },
    dividend: {
      id: 'div',
      rule: FundRuleName.DIVIDEND_STRATEGY,
      text: '',
      value: false,
      level2: undefined,
    },
  }

  constructor() {
    const aemCassDataFromSession = sessionStorage.getItem(
      SESSION_STORAGE_CONSTANTS_CAAS_CONTENT,
    )
    const parsedCaasJson = JSON.parse(aemCassDataFromSession)
    if (parsedCaasJson.data.fd3filtersList) {
      this.assetCaas = parsedCaasJson.data.fd3filtersList.items[0]
      this.initProperties(this.assetCaas)
    }
  }
  initProperties(assetCaas: any) {
    this.filterByLevel1 = {
      equity: {
        id: 'eq',
        rule: FundRuleName.EQUITY,
        text: assetCaas.equity,
        value: false,
        level2: this.equityLevel2,
      },
      fixedIncome: {
        id: 'fi',
        rule: FundRuleName.FIXED_INCOME,
        text: assetCaas.fixedIncome,
        value: false,
        level2: this.fixedincomeLevel2,
      },
      multiAsset: {
        id: 'muAst',
        rule: FundRuleName.MULTI_ASSET,
        text: assetCaas.multiAsset,
        value: false,
        level2: this.multiAssetLevel2,
      },
      cashEquivalent: {
        id: 'ce',
        rule: FundRuleName.CASH_EQUIVALENT,
        text: assetCaas.cashEquivalent,
        value: false,
        level2: this.cashEquivalentLevel2,
      },
      factorDriven: {
        id: 'factDr',
        rule: FundRuleName.FACTOR_DRIVEN_STRATEGY,
        text: assetCaas.factorDriven,
        value: false,
        level2: undefined,
      },
      esg: {
        id: 'esg',
        rule: FundRuleName.ESG_STRATEGY,
        text: assetCaas.esg,
        value: false,
        level2: undefined,
      },
      sectorSpecialties: {
        id: 'secspec',
        rule: FundRuleName.SECTOR_SPECIALITY_STRATEGY,
        text: assetCaas.sector,
        value: false,
        level2: undefined,
      },
      dividend: {
        id: 'div',
        rule: FundRuleName.DIVIDEND_STRATEGY,
        text: assetCaas.dividend,
        value: false,
        level2: undefined,
      },
    }
    this.filterByLevel1.equity.level2 = [
      {
        id: 'eqUs',
        rule: FundRuleName.EQUITY_US,
        text: assetCaas.US,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'eqIntl',
        rule: FundRuleName.EQUITY_INTERNATIONAL,
        text: assetCaas.international,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },

      {
        id: 'eqDev',
        rule: FundRuleName.EQUITY_DEVELOPED,
        text: assetCaas.developed,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'eqEmrg',
        rule: FundRuleName.EQUITY_EMERGING,
        text: assetCaas.emerging,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'eqGl',
        rule: FundRuleName.EQUITY_GLOBAL,
        text: assetCaas.global,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'eqNUs',
        rule: FundRuleName.EQUITY_NON_US,
        text: assetCaas.nonus,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },

      {
        id: 'blend',
        rule: FundRuleName.EQUITY_BLEND,
        text: assetCaas.blend,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
        ],
      },
      {
        id: 'gr',
        rule: FundRuleName.EQUITY_GROWTH,
        text: assetCaas.growth,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
        ],
      },
      {
        id: 'val',
        rule: FundRuleName.EQUITY_VALUE,
        text: assetCaas.value,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
        ],
      },

      {
        id: 'lrg',
        rule: FundRuleName.EQUITY_LARGE,
        text: assetCaas.large,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
        ],
      },
      {
        id: 'mid',
        rule: FundRuleName.EQUITY_MID,
        text: assetCaas.mid,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
        ],
      },
      {
        id: 'sm',
        rule: FundRuleName.EQUITY_SMALL,
        text: assetCaas.small,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
        ],
      },

      {
        id: 'eqActv',
        rule: FundRuleName.EQUITY_ACTIVE,
        text: assetCaas.active,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'eqIndex',
        rule: FundRuleName.EQUITY_INDEX,
        text: assetCaas.index,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
    ]
    this.filterByLevel1.fixedIncome.level2 = [
      {
        id: 'fiUs',
        rule: FundRuleName.FI_US,
        text: assetCaas.US,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'fiIntl',
        rule: FundRuleName.FI_INTERNATIONAL,
        text: assetCaas.international,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },

      {
        id: 'fiDev',
        rule: FundRuleName.FI_DEVELOPED,
        text: assetCaas.developed,
        value: false,
        productTypes: [assetCaas.allFunds, assetCaas.mutualFunds],
      },
      {
        id: 'fiEmrg',
        rule: FundRuleName.FI_EMERGING,
        text: assetCaas.emerging,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'fiGl',
        rule: FundRuleName.FI_GLOBAL,
        text: assetCaas.global,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'fiNUS',
        rule: FundRuleName.FI_NON_US,
        text: assetCaas.nonus,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
        ],
      },
      {
        id: 'MultiS',
        rule: FundRuleName.FI_MULTI_SECTOR,
        text: assetCaas.multisector,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.trusts,
        ],
      },

      {
        id: 'bInvGr',
        rule: FundRuleName.FI_BELOW_INV_GRADE,
        text: assetCaas.belowInv,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'invGr',
        rule: FundRuleName.FI_INV_GRADE_CORP,
        text: assetCaas.invGrade,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'fiMu',
        rule: FundRuleName.FI_MUNI,
        text: assetCaas.municipal,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'tAgncy',
        rule: FundRuleName.FI_TREASURY_AGENCY,
        text: assetCaas.treasury,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },

      {
        id: 'lng',
        rule: FundRuleName.FI_LONG,
        text: assetCaas.long,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'interm',
        rule: FundRuleName.FI_INTERMEDIATE,
        text: assetCaas.intermediate,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'sh',
        rule: FundRuleName.FI_SHORT,
        text: assetCaas.short,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },

      {
        id: 'fiActv',
        rule: FundRuleName.FI_ACTIVE,
        text: assetCaas.active,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
      {
        id: 'fiIndex',
        rule: FundRuleName.FI_INDEX,
        text: assetCaas.index,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.etf,
          assetCaas.trusts,
        ],
      },
    ]
    this.filterByLevel1.multiAsset.level2 = [
      {
        id: 'muUs',
        rule: FundRuleName.MULTI_ASSET_US,
        text: assetCaas.US,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.trusts,
        ],
      },
      {
        id: 'muIntl',
        rule: FundRuleName.MULTI_ASSET_INTL,
        text: assetCaas.international,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.trusts,
        ],
      },
      {
        id: 'bal',
        rule: FundRuleName.MULTI_ASSET_BALANCE,
        text: assetCaas.balanced,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.trusts,
        ],
      },
      {
        id: 'trgAlloc',
        rule: FundRuleName.MULTI_ASSET_TARGET_ALLOCATION,
        text: assetCaas.targetAllocation,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.trusts,
        ],
      },
      {
        id: 'trgDt',
        rule: FundRuleName.MULTI_ASSET_TARGET_DATE,
        text: assetCaas.targetDate,
        value: false,
        productTypes: [
          assetCaas.allFunds,
          assetCaas.mutualFunds,
          assetCaas.trusts,
        ],
      },
    ]
    this.filterByLevel1.cashEquivalent.level2 = [
      {
        id: 'tx',
        rule: FundRuleName.CASH_EQUIVALENTS_TAXABLE,
        text: assetCaas.taxable,
        value: false,
        productTypes: [assetCaas.allFunds, assetCaas.mutualFunds],
      },
      {
        id: 'ceMu',
        rule: FundRuleName.CASH_EQUIVALENTS_MUNI,
        text: assetCaas.municipal,
        value: false,
        productTypes: [assetCaas.allFunds, assetCaas.mutualFunds],
      },
      {
        id: 'ceStb',
        rule: FundRuleName.CASH_EQUIVALENTS_STABLE_VALUE,
        text: assetCaas.stableValue,
        value: false,
        productTypes: [assetCaas.allFunds, assetCaas.trusts],
      },
    ]
  }
}
